import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ number, eyebrow, title, subtitle, center = true }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <span className="inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.22em] text-aqua">
        <span className="text-brand/60">{number}</span>
        <span className="h-px w-6 bg-aqua/50" aria-hidden="true" />
        {eyebrow}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-slate-500 md:text-lg">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
